import { ExternalResourceType } from "../enums";
import { ExternalResourceLink } from "../types";

export function parseLink(href: string, index?: number): ExternalResourceLink {
  let title = href;

  try {
    const url = new URL(href);
    title = url.host;

    if (title.includes("asana")) {
      title = "Asana";
    }

    if (title.includes("thesoul")) {
      title = "TheSoul";
    }

    if (title.includes("teamwox")) {
      title = "Teamwox";
    }
  } catch (error) {
    // nothing
  }

  if (typeof index === "number") {
    title = `${title} #${index + 1}`;
  }

  return {
    type: ExternalResourceType.LINK,
    title,
    href,
  };
}
